import { render, staticRenderFns } from "./SupporterList.vue?vue&type=template&id=da0ae84a&scoped=true&"
import script from "./SupporterList.vue?vue&type=script&lang=js&"
export * from "./SupporterList.vue?vue&type=script&lang=js&"
import style0 from "./SupporterList.vue?vue&type=style&index=0&id=da0ae84a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0ae84a",
  null
  
)

export default component.exports